<template>
  <div>
    <InfoDialog
      title="Refer one of your contacts and earn rewards when they are engaged on an opportunity"
      content-class="refer-contact-rewards-dialog"
      :show="show"
      :content-style="contentStyle"
      @hide="handleDialogHide"
    >
      <div>
        <ul class="reset-list">
          <li>
            <strong>Step 1:</strong>  You invite your contacts to the Riverflex platform through the invite feature on the connections page.
          </li>
          <li>
            <strong>Step 2:</strong> Your contacts accept the invite and join the Riverflex platform
          </li>
          <li>
            <strong>Step 3:</strong> They get sourced for an opportunity facilitated by Riverflex within 1 year!
          </li>
          <li>
            <strong>Step 4:</strong> Congratulations! Time for your reward!
          </li>
        </ul>
        <p class="mt-2">
          <i>*Contact us for terms and conditions on this reward</i>
        </p>
        <div class="text-center">
          <v-btn
            v-if="showReferContactBtn"
            class="mt-3"
            color="primary"
            rounded
            light
            @click="handleReferContactClick"
          >
            Refer a contact now!
          </v-btn>
        </div>
      </div>
    </InfoDialog>
    <v-dialog
      v-model="showAddConnectionDialog"
      :retain-focus="false"
      transition="slide-y-transition"
    >
      <addConnection
        :show-more-info="showMoreInfo"
        @hide="showAddConnectionDialog = false"
      />
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import InfoDialog from '@/components/core/InfoDialog.vue'
import addConnection from '@/components/connections/AddConnection.vue'
import { PURPLE_BG_GRADIENT_TOP } from '@/constants'
import { referContactRewardEvents } from '@/segmentAnalytics/rewards'

@Component({
  components: {
    InfoDialog,
    addConnection
  }
})
export default class ReferContactDialog extends Vue {
  @Prop({ required: true }) show: boolean
  @Prop({ default: true }) showReferContactBtn: boolean
  @Prop({ default: false }) showMoreInfo: boolean

  contentStyle: string = PURPLE_BG_GRADIENT_TOP
  showAddConnectionDialog: boolean = false

  handleReferContactClick () {
    referContactRewardEvents.trackReferContact()
    this.showAddConnectionDialog = true
  }

  handleDialogHide () {
    referContactRewardEvents.trackClose()
    this.$emit('hide')
  }
}
</script>
<style lang='scss'>
.refer-contact-rewards-dialog {
  &.v-card,
  .v-btn.v-btn--icon,
  a {
    color: #fff !important;
  }

  .info-icon {
    background-image: none;
    background-color: #fff;
    color: #8E59FF;
  }
}
</style>
